import axios from 'axios';
import apiClient from './apiClient';
import { extractDataArray } from './utils/apiResponseUtils';
import { handleApiError as handleError } from './utils/apiErrorUtils';
import { BaseCrudService } from './base/BaseCrudService';

// Loader interfaces aligned with API specification
export interface Loader {
  id: number;
  uuid?: string;
  name?: string;
  description?: string;
  loader_type?: string;
  // Support both naming conventions
  platform_id?: number;
  platform?: number;
  platform_name?: string;
  job_type_id?: number;
  job_type?: number;
  job_type_name?: string;
  job_type_code?: string;
  config?: any;
  extraction_plan?: any;
  loading_plan?: any;
  version?: number;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
}

export interface LoaderListResponse {
  count: number;
  results: Loader[];
}

export interface LoaderCreate {
  name: string;
  description?: string;
  loader_type: string;
  platform_id?: number;
  config?: any;
  is_active?: boolean;
}

export interface LoaderListParams {
  platform_id?: number;
  loader_type?: string;
  is_active?: boolean;
}

class LoaderService extends BaseCrudService<Loader, LoaderCreate, LoaderCreate, LoaderListParams> {
  constructor() {
    super({
      basePath: '/api/loaders/',
      entityName: 'loader',
      arrayKeys: ['loaders', 'results', 'data'],
    });
  }
  async getAllLoaders(params?: LoaderListParams): Promise<Loader[]> {
    return this.getAll(params);
  }

  /**
   * Gets loader configurations for YAML generation
   */
  async getLoaderConfigs(): Promise<Loader[]> {
    try {
      const response = await apiClient.get<any>('/loaders/');
      
      
      return extractDataArray<Loader>(response.data, ['loaders', 'results', 'data']);
    } catch (error) {
      console.error('Failed to fetch loader configs:', error);
      return [];
    }
  }

  async getLoader(id: number): Promise<Loader | null> {
    return this.getById(id);
  }

  async createLoader(data: LoaderCreate): Promise<Loader> {
    return this.create(data);
  }

  async updateLoader(id: number, data: Partial<LoaderCreate>): Promise<Loader> {
    return this.update(id, data as LoaderCreate);
  }

  async deleteLoader(id: number): Promise<void> {
    return this.delete(id);
  }

}

export const loaderService = new LoaderService();